import antiAgingBelugaQuestions from './initial/anti-aging-beluga';
import antiAging from './initial/anti-aging';
import antiAgingBelugaFollowupQuestions from './monthly';

const antiAgingQuestions = [
  ...antiAgingBelugaQuestions,
  ...antiAgingBelugaFollowupQuestions,
  ...antiAging
];
export default antiAgingQuestions;
